import React from 'react';
import { PlainModal, PlainModalProps } from './modal';
import { Typography } from '../typography/typography';
import { ConfettiOverlay } from '../confettiOverlay';

type ConfettiModalProps = PlainModalProps & {
  title?: string;
  children: React.ReactNode;
};

export const ConfettiModal = (p: ConfettiModalProps) => (
  <>
    <ConfettiOverlay isActive={p.isOpen} />
    <PlainModal {...p}>
      <div className="text-center">
        {p.title ? (
          <Typography variant="display" size="small">
            {p.title}
          </Typography>
        ) : null}
        {p.children}
      </div>
    </PlainModal>
  </>
);
